import { render } from "./registration-form.vue?vue&type=template&id=39e7d8c8&scoped=true"
import script from "./registration-form.vue?vue&type=script&lang=ts"
export * from "./registration-form.vue?vue&type=script&lang=ts"

import "./registration-form.vue?vue&type=style&index=0&id=39e7d8c8&lang=scss&scoped=true"
import "./registration-form.vue?vue&type=style&index=1&id=39e7d8c8&lang=css"
script.render = render
script.__scopeId = "data-v-39e7d8c8"

export default script